import { pushMessage } from 'actionCreators/messages';
import { getStore } from '../redux/store';

const toast = (message: string, type: 'success' | 'error' | 'info' | 'warning') => {
  const store = getStore();
  if (!store) return;
  store.dispatch(pushMessage(message, type));
};

export const toastSuccess = (message: string) => toast(message, 'success');

export const toastError = (message: string) => toast(message, 'error');